import { $, $$, setAttributes } from 'utils/dom';
import { uniqueId } from 'utils/helper';
import Bus from 'modules/event-bus';
import Shower from 'modules/shower';

class HighlightTeaser {
  constructor(props) {
    this.container = props.container;
    this.target = $('.highlight-teaser__hidden-items', this.container);
    this.handler = $('.highlight-teaser__btn', this.container);
    this.breakpoint = 1200;
    this.mobileShower = null;
    this.mobileShowerIsInitialized = false;
  }

  initMobileShower = () => {
    const randomID = uniqueId();

    setAttributes(this.handler, {
      id: `highlight-teaser-btn-${randomID}`,
      'aria-controls': `highlight-teaser-tab-${randomID}`,
    });

    setAttributes(this.target, {
      id: `highlight-teaser-tab-${randomID}`,
      'aria-labelledby': `highlight-teaser-btn-${randomID}`,
    });

    this.mobileShower = new Shower({
      target: this.target,
      handler: this.handler,
      easing: 'easeInOutQuart',
      duration: 300,
      initOpened: false,
    });

    if (
      window.innerWidth < this.breakpoint &&
      !this.mobileShowerIsInitialized
    ) {
      this.mobileShower.init();
      this.mobileShowerIsInitialized = true;
    }
  };

  onResize = () => {
    if (window.innerWidth >= this.breakpoint) {
      if (this.mobileShowerIsInitialized) {
        this.mobileShower && this.mobileShower.destroy();
        this.mobileShower = null;
        this.mobileShowerIsInitialized = false;
      }
    } else {
      if (!this.mobileShowerIsInitialized) {
        this.initMobileShower();
      }
    }
  };

  bindEvents = () => {
    Bus.subscribe('resize', 'HighlightTeaser', this.onResize);
  };

  init = () => {
    this.bindEvents();
    this.target && this.handler && this.initMobileShower();
  };
}

const highlightTeasers = $$('.highlight-teaser');
highlightTeasers.length &&
  highlightTeasers.forEach(teaser => {
    new HighlightTeaser({
      container: teaser,
    }).init();
  });
